module.exports = __webpack_public_path__ + "static/media/icon.cc164bb6.png";